import * as React from "react";
// Hooks and utilities
import { get } from "lodash";
import { observer, inject } from "mobx-react";
import addCommas from "helpers/index";
import UserStore from "state/user";
// Styles
import styles from "./index.module.scss";

interface IProps {
	user?: UserStore;
}
const CreditAmount: React.FC<IProps> = props => {
	return (
		<div className={styles["credit-amount"]}>
			<div className={styles["credit-amount__title"]}>موجودی حساب شما</div>
			{!get(props.user, ["loading"]) ? (
				<div>
					<span className={styles["credit-amount__balance"]}>
						{addCommas(get(props.user, ["balance"])) || 0}
					</span>
					<span>ریال</span>
				</div>
			) : (
				"در حال بارگزاری..."
			)}
		</div>
	);
};
export default inject("user")(observer(CreditAmount));
